<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col w-full flex justify-between">
                    <h3 class="list-project">{{ $t('tasks.projectList') }}</h3>
                    <vs-button color="primary" icon-pack="feather" icon="icon-plus" type="border" @click="clearValue"
                               v-if="isPermission() && employeeOptionSearch.length > 1">
                        {{ $t('tasks.addProject') }}
                    </vs-button>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full" v-if="userInfo.userRole === 'organization'">
                    <label class="vs-input--label">{{ $t('tasks.personInCharge') }}</label>
                    <v-select class="" v-model="selecEmployee" :options="employeeOptionSearch"
                              :reduce="(options) => options.value">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full md:mt-0 mt-2">
                    <label class="vs-input--label">{{ $t('tasks.status') }}</label>
                    <v-select class="" v-model="projectDataStt" :options="statusOptionsSearch"
                              :reduce="(options) => options.value">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full lg:mt-0 mt-2">
                    <label class="vs-input--label">{{ $t('tasks.startTimeAndEndTime') }}</label>
                    <date-range-picker ref="picker" class="w-full" :locale-data="{ format: 'dd/mm/yyyy' }"
                                       :opens="'left'" @update="dateRangePicker" v-model="dateRange">
                    </date-range-picker>

                </div>
                <div class="vx-col xl:w-1/4 lg:w-full md:w-1/2 w-full lg:mt-6 md:mt-8 mt-4">
                    <vs-button color="primary" icon-pack="feather" icon="icon-search" class="float-right"
                               @click="getProject">{{
                            $t('tasks.search')
                        }}
                    </vs-button>
                </div>
            </div>
        </div>
        <div class="vx-card p-6 mt-6">
            <vs-table id="title-item" stripe noDataText="Không có dữ liệu" :data="colums" v-model="selected">
                <template slot="thead">
                    <vs-th class="title">
                        STT
                    </vs-th>
                    <vs-th class="title">
                        {{ $t('tasks.title') }}
                    </vs-th>
                    <vs-th class="title"> {{ $t('tasks.numberOfTask') }}</vs-th>
                    <vs-th class="title"> {{ $t('tasks.personInCharge') }}</vs-th>
                    <vs-th class="title"> {{ $t('tasks.createdDate') }}</vs-th>
                    <vs-th class="item"> {{ $t('tasks.startDate') }}</vs-th>
                    <vs-th class="item"> {{ $t('tasks.deadline') }}</vs-th>
                    <vs-th class="title"> {{ $t('tasks.projectProgress') }}</vs-th>
                    <vs-th class="title"> {{ $t('tasks.status') }}</vs-th>
                    <vs-th class="title"> {{ $t('tasks.action') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr v-for="(colum, ind) in data" :data="colum" :key="ind" class="cursor-pointer">
                        <vs-td>
                            {{ ind + 1 }}
                        </vs-td>
                        <vs-td class="text-primary">
                            {{ colum.title }}
                        </vs-td>
                        <vs-td>{{ colum.taskCount }}</vs-td>
                        <vs-td>
                            <div v-if="colum.responsibleEmployee">{{ colum.responsibleEmployee.fullName }}</div>
                        </vs-td>
                        <vs-td>{{ colum.createdDateCvt }}</vs-td>
                        <vs-td>{{ colum.startTimeCvt }}</vs-td>
                        <vs-td
                            :style="{ color: timestampToDate(colum.endTime) < timestampToDate(currentDate) && colum.status !== 2 ? 'rgba(var(--vs-danger), 1)' : 'rgba(var(--vs-success), 1)' }">
                            {{
                                colum.endTimeCvt
                            }}
                        </vs-td>
                        <vs-td>
                            {{ colum.completedPercentage }}%
                        </vs-td>
                        <vs-td>
                            <vs-chip :color="chipColor(colum.status)">{{
                                    status(colum.status)
                                }}
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            <div class="flex">
                                <vx-tooltip class="position-icon mr-2" :text="$t('button.details')" position="top">
                                    <feather-icon icon="ArrowUpRightIcon" class="text-primary"
                                                  svgClasses="h-5 w-5"
                                                  @click="$router.push(`/user/assign-project-detail?id=${colum.id}`)"/>
                                </vx-tooltip>
                                <vx-tooltip class="position-icon mr-2" :text="$t('button.edit')" position="top"
                                            v-if="isPermission()">
                                    <feather-icon icon="SettingsIcon" class="text-warning"
                                                  svgClasses="h-5 w-5"
                                                  @mousedown.stop="openUpdates(colum.id, colum)"/>
                                </vx-tooltip>
                                <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top"
                                            v-if="isPermission()">
                                    <feather-icon icon="TrashIcon" class="text-danger"
                                                  svgClasses="h-5 w-5"
                                                  @click="deleteProject(colum.id)"/>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <div class="vx-row mt-8 flex" v-if="totalElements > 0">
                <div class="vx-col md:w-1/2 w-full">
                    <!--                    <span class="content-page font-bold">Hiển thị: </span>-->
                    <!--                    <span class="text-page">-->
                    <!--                        {{ colums.length }} / {{ totalElements }}-->
                    <!--                    </span>-->
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" :max="10" v-model="currentPage" @change="changePage"/>
                </div>
            </div>
        </div>

        <vs-popup :title="!id ? $t('tasks.addProject') : $t('tasks.update')" :active.sync="popupProject">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> {{ $t('tasks.title') }}</label><br/>
                <vs-input v-model="projectData.title" class="w-full" v-validate="'required'" name="title"/>
                <span class="text-danger text-sm">{{ errors.first('title') }}</span>
            </div>
            <div class="vx-col md:w-full mt-4">
                <label class="vs-input--label"> {{ $t('tasks.type') }}</label><br/>
                <vs-input v-model="projectData.type" class="w-full"/>
            </div>
            <div class="vx-col mt-4">
                <label class="vs-input--label">{{ $t('tasks.description') }}</label><br/>
                <vs-textarea class='w-full' style="padding-left: 2px; color: inherit; font-size: 1rem !important; "
                             name="" id="" cols="46" rows="2" v-model="projectData.description"></vs-textarea>
            </div>
            <!--            <div class="vx-col md:w-full mt-4">-->
            <!--                <label class="vs-input&#45;&#45;label">{{ $t('tasks.client') }}</label><br/>-->
            <!--                <vs-input v-model="projectData.client" class="w-full"/>-->
            <!--            </div>-->
            <div class="vx-col w-full mt-4">
                <label class="vs-input--label required">{{ $t('tasks.status') }}</label>
                <v-select class="w-full" v-model="projectData.status" :clearable="false" :options="statusOptions"
                          :reduce="(options) => options.value" v-validate="'required'" name="stt">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('stt') }}</span>
            </div>
            <div class="vx-col w-full mt-4">
                <label class="vs-input--label required">{{ $t('tasks.personInCharge') }}</label>
                <v-select class="w-full" v-model="projectData.responsibleEmployeeId" :clearable="false"
                          :options="employeeOptionsSelect" :reduce="(options) => options.value" v-validate="'required'"
                          name="personInCharge">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('personInCharge') }}</span>
            </div>
            <div class="vx-col w-full mt-4" v-if="id">
                <label class="vs-input--label">{{ $t('tasks.completedPercentage') }}</label>
                <div class="px-4">
                    <vs-slider color="primary" text-fixed=% v-model="projectData.completedPercentage"/>
                </div>
            </div>
            <div class="flex mt-4">
                <div class="vx-col md:w-1/2 w-1/2 mt-4">
                    <label class="vs-input--label">{{ $t('tasks.startDate') }}</label>
                    <div class="w-full">
                        <datepicker :highlighted="highlighted" class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                    v-model="selectstartDate" data-vv-validate-on="input" ref="datepickBooking"
                                    name="timeStart">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('timeStart') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-1/2 mt-4 ml-2">
                    <label class="vs-input--label">{{ $t('tasks.hours') }}</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectStartTime"
                                    class="w-full vs-inputx vs-input--input normal"
                                    name="hourStart"/>
                    </div>
                    <span class="text-danger text-sm">{{ errors.first('hourStart') }}</span>
                </div>
            </div>
            <div class="flex mt-4">
                <div class="vx-col md:w-1/2 w-1/2 mt-4">
                    <label class="vs-input--label">{{ $t('tasks.deadline') }}</label>
                    <div class="w-full">
                        <datepicker :highlighted="highlighted" class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                    v-model="selectEndDate" data-vv-validate-on="input" ref="datepickBooking"
                                    name="timeEnd">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('timeEnd') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-1/2 mt-4 ml-2">
                    <label class="vs-input--label">{{ $t('tasks.hours') }}</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectEndTime"
                                    class="w-full vs-inputx vs-input--input normal"
                                    name="hourEnd"/>
                    </div>
                    <span class="text-danger text-sm">{{ errors.first('hourEnd') }}</span>
                </div>
            </div>


            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="saveUpdateProject" v-if="id">{{
                                $t('tasks.update')
                            }}
                        </vs-button>
                        <vs-button class="mr-5" @click="saveProject" v-else>{{ $t('tasks.addProject') }}</vs-button>
                        <vs-button class="" color="danger" type="border" @click="popupProject = false">{{
                                $t('tasks.close')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import DateRangePicker from "../../../components/vue2-daterange-picker/components/DateRangePicker.vue";
import VueFlatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from "vue-select";
import Multiselect from 'vue-multiselect';
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {vi} from 'vuejs-datepicker/dist/locale';
import {isAPI} from "../../../store/permission";
import {constAPI} from "../../../store/constant";

export default {
    components: {
        DateRangePicker,
        vSelect,
        Multiselect,
        VueFlatpickr,
        VuePerfectScrollbar, Datepicker, flatPickr
    },
    data() {
        return {
            vi: vi,
            id: null,
            popupProject: false,
            popupProjectDetails: false,
            colums: [],
            projectData: {
                title: null,
                status: null,
                client: null,
                responsibleEmployeeId: null,
                labels: [],
                taskCount: null,
                description: null,
                type: null,
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            projectDataStt: 'null',
            statusOptions: [],
            statusOptionsSearch: [],
            employeeOptions: [],
            employeeOptionSearch: [],
            employeeOptionsSelect: [],
            labelsOptions: [],
            labelColor: [],
            selecEmployee: 'null',
            permissions: ['PRIVILEGE_PROJECT_MANAGER'],
            organizationId: 'null',
            page: 0,
            pageSize: 20,
            totalElements: 0,
            countElementPage: 0,
            totalPages: 0,
            currentPage: 1,
            selectedOrganizationBranch: null,
            currentDate: new Date(),
            dateRange: {
                endDate: null,
                startDate: null
            },
            dateRangeDeadline: {
                endDate: new Date(new Date().setDate(new Date().getDate() + 12)),
                startDate: new Date(new Date().setDate(new Date().getDate() - 7))
            },
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
            },
            selectedLabel: [],
            startDateAddRange: {
                startDate: new Date(new Date()),
                endDate: new Date(new Date()),
            },
            selectstartDate: null,
            selectStartTime: null,
            selectEndDate: null,
            selectEndTime: null,
            date: {
                selectDateFormat: null
            },
            StartDate: null,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            selected: [],
        };
    },
    watch: {
        selected(val) {
            this.$router.push(`/user/assign-project-detail?id=${val.id}`)
        }
    },

    async created() {
        let branchList = JSON.parse(localStorage.getItem("branchInfoList") || "[]");
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t("warningMenuOrganization.emptyEmployee"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
            });
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map((item) => {
            return {value: item.id, label: item.organizationBranchName};
        });
        this.organizationBranchOptions.unshift({
            value: null,
            label: this.$t("menuOrganization.all"),
        });
        if (this.userInfo.userRole === 'organization') await this.getEmployee();
        await this.getStt();
        await this.getLabel();
        await this.getEmployeeSearch();
        this.getProject();
    },
    methods: {
        timestampToDate(timestamp) {
            return new Date(timestamp).getTime();
        },
        clearValue() {
            console.log(this.selected)
            this.id = null;
            this.popupProject = true
            this.projectData = []
            this.selectstartDate = null
            this.selectStartTime = null
            this.selectEndDate = null
            this.selectEndTime = null
            this.selectedLabel = null
            this.$validator.reset()
        },
        dateRangePicker() {
            this.dateRange.startDate = new Date(this.dateRange.startDate);
            this.dateRange.endDate = new Date(this.dateRange.endDate);
        },

        openUpdates(id, colum) {
            this.id = id;
            if (colum.startTime && colum.endTime) {
                this.selectstartDate = colum.startTime
                this.selectStartTime = new Date(colum.startTime).getHours() + ':' + new Date(colum.startTime).getMinutes() + ':' + new Date(colum.startTime).getSeconds()
                this.selectEndDate = colum.endTime
                this.selectEndTime = new Date(colum.endTime).getHours() + ':' + new Date(colum.endTime).getMinutes() + ':' + new Date(colum.endTime).getSeconds()
            }
            this.projectData = {
                title: colum.title,
                status: colum.status,
                client: colum.client,
                responsibleEmployeeId: colum.responsibleEmployee.employeeId,
                description: colum.description,
                type: colum.type,
                completedPercentage: colum.completedPercentage
            }
            this.selectedLabel = colum.labelResponses.map(el => {
                return {
                    value: el.label,
                    label: el.label
                }
            })
            this.popupProject = true;
        },

        getProject() {
            let body = {
                page: this.page,
                pageSize: this.pageSize,
                endTime: this.dateRange.endDate,
                startTime: this.dateRange.startDate,
                status: this.projectDataStt,
                employeeId: this.userInfo.userRole !== 'organization' ? this.userInfo.employeeId : this.selecEmployee,
            };
            // if (this.userInfo.userRole !== 'organization') body['employeeId'] = this.userInfo.employeeId
            this.$vs.loading();
            this.$crm.post(`/project/find-by-condition`, body).then((response) => {
                this.$vs.loading.close();
                if (response.data.content && response.data.content.length > 0) {
                    this.colums = response.data.content.map(t => {
                        t.startTimeCvt = t.startTime ? moment(t.startTime).format('DD/MM/YYYY HH:mm') : ''
                        t.endTimeCvt = t.endTime ? moment(t.endTime).format('DD/MM/YYYY HH:mm') : ''
                        t.completedPercentage = t.completedPercentage ? t.completedPercentage.toFixed(0) : 0
                        t.createdDateCvt = t.createdDate ? moment(t.createdDate).format('DD/MM/YYYY HH:mm') : ''
                        return t
                    })
                } else {
                    this.colums = [];
                }
                this.totalPages = response.data.totalPages;
                this.totalElements = response.data.totalElements;
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        getEmployee() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post(`/employee/all`, {enabled: true,}).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.employeeOptions = response.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },

        getEmployeeSearch() {
            return new Promise((resolve, reject) => {
                this.organizationId = JSON.parse(localStorage.getItem("userInfo"));

                let body = {
                    permissions: this.permissions,
                    organizationId: this.organizationId.organization.id
                }
                this.$vs.loading();
                this.$crm.post(`/employee/get-employees-by-permissions`, body).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.employeeOptionsSelect = response.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                        this.employeeOptionSearch = response.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                        this.employeeOptionSearch.unshift({value: 'null', label: 'Tất cả'})
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },
        getStt() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/setting/organization-task-status/find-by-organization-id`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.statusOptions = response.data.map((el) => {
                            return {
                                value: el.status,
                                label: el.title,
                                color: el.color
                            };
                        });
                        this.statusOptionsSearch = response.data.map((el) => {
                            return {value: el.status, label: el.title};
                        });
                        this.statusOptionsSearch.unshift({value: 'null', label: 'Tất cả'});
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },
        getLabel() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/setting/organization-task-label/find-by-organization-id`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.labelColor = response.data
                        this.labelsOptions = response.data.map(el => {
                            return {
                                value: el.label,
                                label: el.label
                            }
                        })
                    }
                    resolve(response)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                })
            })
        },
        async saveUpdateProject() {
            if (this.selectstartDate && this.selectStartTime && this.selectEndDate && this.selectEndTime) {
                const hours = parseInt(this.selectStartTime.split(':')[0]);
                const minutes = parseInt(this.selectStartTime.split(':')[1]);
                this.selectstartDate = new Date(this.selectstartDate)
                this.selectstartDate.setHours(hours, minutes, 0, 0);

                const hoursEnd = parseInt(this.selectEndTime.split(':')[0]);
                const minutesEnd = parseInt(this.selectEndTime.split(':')[1]);
                this.selectEndDate = new Date(this.selectEndDate)
                this.selectEndDate.setHours(hoursEnd, minutesEnd, 59, 999);

                if (new Date(this.selectstartDate).getTime() >= new Date(this.selectEndDate).getTime()) {
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    })
                }
            }

            let body = {
                title: this.projectData.title,
                responsibleEmployeeId: this.projectData.responsibleEmployeeId,
                labels: this.projectData.labels,
                description: this.projectData.description,
                startTime: this.selectstartDate ? new Date(this.selectstartDate).toISOString() : null,
                endTime: this.selectEndDate ? new Date(this.selectEndDate).toISOString() : null,
                status: this.projectData.status,
                client: this.projectData.client,
                type: this.projectData.type,
                completedPercentage: this.projectData.completedPercentage
            }
            this.$vs.loading();
            this.$crm.post(`/project/update/${this.id}`, body).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.popupProjectDetails = false;
                this.$store.commit('UPDATE_TASK_KANBAN', true);
                this.popupProject = false;
                this.getProject();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        async saveProject(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            if (this.selectStartTime && this.selectstartDate) {
                const hours = parseInt(this.selectStartTime.split(':')[0]);
                const minutes = parseInt(this.selectStartTime.split(':')[1]);
                this.selectstartDate = new Date(this.selectstartDate)
                this.selectstartDate.setHours(hours, minutes, 0, 0);
            }

            if (this.selectEndTime && this.selectEndDate) {
                const hoursEnd = parseInt(this.selectEndTime.split(':')[0]);
                const minutesEnd = parseInt(this.selectEndTime.split(':')[1]);
                this.selectEndDate = new Date(this.selectEndDate)
                this.selectEndDate.setHours(hoursEnd, minutesEnd, 59, 999);
            }

            if (this.selectstartDate && this.selectEndDate && new Date(this.selectstartDate).getTime() >= new Date(this.selectEndDate).getTime()) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }

            let body = {
                title: this.projectData.title,
                type: this.projectData.type,
                status: this.projectData.status,
                client: this.projectData.client,
                responsibleEmployeeId: this.projectData.responsibleEmployeeId,
                labels: this.projectData.labels,
                startTime: this.selectstartDate,
                endTime: this.selectEndDate,
                description: this.projectData.description,
            }
            this.$vs.loading();
            this.$crm
                .post(`/project/create`, body)
                .then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: "success",
                        text: `Tạo mới thành công`,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                    this.popupProject = false;
                    this.getProject();
                })
                .catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: "Lỗi",
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                });
        },
        deleteProject(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa dự án này không ?`,
                accept: () => this.acceptDeleteProject(id),
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },
        acceptDeleteProject(id) {
            this.$vs.loading();
            this.$crm
                .delete(`/project/delete/${id}`)
                .then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `Xóa thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    this.getProject();
                }).catch(err => {
                this.$vs.loading.close();
                this.getProject();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                });

            });
        },

        changeSelectMultiple() {
            this.projectData.labels = [];
            this.selectedLabel.forEach(el => {
                this.projectData.labels.push(el.label);
            })
        },

        changePage(page) {
            this.page = page - 1;
            this.getProject();
        },

        isPermission() {
            return isAPI(this, constAPI.project_manager)
        },

    },
    computed: {
        chipColor() {
            return (value) => {
                return this.statusOptions.find((x) => x.value == value).color;
            };
        },
        status() {
            return (status) => {
                return this.statusOptions.find((x) => x.value == status).label;
            };
        },

        validateForm() {
            return !this.errors.any()
        },
    },
};
</script>

<style>
.title {
    color: #828282;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.071px;
}

.item {
    color: #059862;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.071px;
}

.required::after {
    content: '* ';
    color: red;
}

.list-project {
    color: #059862 !important;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.079px;
}
</style>
